import { render, staticRenderFns } from "./SelectCategoriesTabButtons.vue?vue&type=template&id=54169578&"
import script from "./SelectCategoriesTabButtons.vue?vue&type=script&lang=js&"
export * from "./SelectCategoriesTabButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports